import CounterSlicefrom from "./action.js";
export default CounterSlicefrom.reducer;
